import { initAccordion } from '../components/initAccordion';

window.addEventListener('DOMContentLoaded', handleOnLoad, false);

function handleOnLoad() {
    initAccordion();
}
